import { Box, SxProps, Theme, Typography } from '@mui/material';

interface InfoDisplayItemProps {
    label: string;
    value: string | number;
    isSmallScreen: boolean;
    allowOverlap?: boolean;
    textAlign?: 'left' | 'center' | 'right';
    sx?: SxProps<Theme>;
}

const InfoDisplayItem: React.FC<InfoDisplayItemProps> = ({
    label,
    value,
    isSmallScreen,
    allowOverlap = true,
    textAlign = 'left',
    sx
}: InfoDisplayItemProps) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            minWidth={isSmallScreen ? '100%' : '200px'}
            sx={{
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
                ...(allowOverlap && {
                    gap: '4px'
                }),
                ...sx
            }}
        >
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    color: '#636363',
                    textAlign: textAlign,
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    ...(allowOverlap && {
                        maxWidth: '280px',
                        minWidth: '70px'
                    })
                }}
            >
                {label}:
            </Typography>
            <Typography
                component="span"
                variant="subtitle1"
                color="textSecondary"
                sx={{
                    textAlign: textAlign,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flex: 1,
                    minWidth: 0,
                    ...(allowOverlap && {
                        maxWidth: 'calc(100% - 100px)'
                    })
                }}
            >
                {value}
            </Typography>
        </Box>
    );
};

export default InfoDisplayItem;
